export { default, type IconTilePresetVariant, type IconTileCustomVariant } from './IconTile';
